import axios from 'axios';
import { DEPLOYMENT_URL } from './config';
import { getToken } from './service/authentication';


export default async (token, profile) => {
  let options = {
    baseURL: DEPLOYMENT_URL,
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };

  if (profile) {
    const profileToken = await getToken('doris');
    options.headers['ProfileAuthorization'] = `Bearer ${profileToken}`;
  }

  return axios.create(options);
};
